import { LionMark } from '../components/LionMark.tsx';

export function Login() {
  return (
    <div
      style={{
        minHeight: '100dvh',
        padding: '24px 24px 32px',
        display: 'flex',
        flexDirection: 'column',
        background: 'var(--bg-app)',
        color: 'var(--text-1)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 8 }}>
        <LionMark size={32} />
        <div className="lt-serif" style={{ fontSize: 22, fontWeight: 500, letterSpacing: -0.01 }}>
          Lion Tracker
        </div>
      </div>
      <div style={{ marginTop: 36 }}>
        <div
          className="lt-serif"
          style={{ fontSize: 38, lineHeight: 1.05, fontWeight: 400, letterSpacing: -0.02 }}
        >
          Quiet logging,
          <br />
          <span style={{ color: 'var(--accent)' }}>for the long nights.</span>
        </div>
        <div style={{ fontSize: 14, color: 'var(--text-2)', marginTop: 14, lineHeight: 1.5, maxWidth: 290 }}>
          Track sleep, feeds, pumps and diapers in one tap. Share live with your partner.
        </div>
      </div>
      <div style={{ flex: 1 }} />
      <div
        style={{
          padding: '16px 18px',
          borderRadius: 18,
          background: 'var(--bg-card)',
          border: '1px solid var(--border)',
          color: 'var(--text-2)',
          fontSize: 14,
          textAlign: 'center',
        }}
      >
        Open the invite link your partner sent you, or claim this device with the bootstrap link.
      </div>
    </div>
  );
}
